import { render } from "./BaseCentro.vue?vue&type=template&id=e8dbd4d8&scoped=true"
const script = {}

import "./BaseCentro.vue?vue&type=style&index=0&id=e8dbd4d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dbd4d8"]])

export default __exports__